import { KeyValuePair } from "./KeyValuePair";
import { IntendedUseEnum } from "./IntendedUses";
import { Opportunity } from "./Opportunity";
import generator from "generate-password-ts";

export class InstanceRequest {
  constructor() {
    this.title = "";
    this.prospect = "";
    this.id = "";
    this.region = { id: "", name: "" };
    this.demoTemplateId = 0;
    this.password = InstanceRequest.generateNewPassword();
    this.link = "";
    this.hdpUsername = "";
    this.comment = "";
  }
  title: string;
  hdpUsername: string;
  id: string;
  prospect: string | Opportunity;
  prospectId?: string;
  region: KeyValuePair<string>;
  demoTemplateId: number;
  intendedUse: IntendedUseEnum;
  password: string;
  link: string;
  comment: string;

  static passwordPattern = /^(?=.*[0-9])(?=.*[- ?!@#$%^&*/\\])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9- ?!@#$%^&*/\\]{8,12}$/;
  static vmPattern = /0123456789abcdefghijklmnopqrstuvwxyz/;

  static generateNewPassword(): string {
    let newPwd;
    let isValid = false;

    do {
      newPwd = generator.generate({
        length: 12,
        numbers: true,
        lowercase: true,
        uppercase: true,
        symbols: true,
        exclude: "',@,&,|,`,/,\\,[,],~,{,},^,>,<,#,$,\",(,)"
      });
      isValid = InstanceRequest.passwordPattern.test(newPwd);
    } while (!isValid);

    return newPwd;
  }

  static generateVmName(): string {
    return generator.generate({ length: 14, numbers: true, lowercase: true, uppercase: false, symbols: false });
  }
}
